import { Outlet } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import { Home, FileText, Compass, HardDrive, Wrench, ArrowLeft } from 'lucide-react';
import { useAuthContext } from './AuthProvider';

const navigation = [
  { name: '主页', icon: Home, href: '/admin' },
  { name: '博客', icon: FileText, href: '/admin/blog' },
  { name: '导航', icon: Compass, href: '/admin/navigation' },
  { name: '云盘', icon: HardDrive, href: '/admin/cloud' },
  { name: '工具', icon: Wrench, href: '/admin/tools' }
];

export default function Layout() {
  const location = useLocation();
  const { user } = useAuthContext();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 顶部导航 */}
      <header className="bg-white shadow-sm">
        <div className="flex items-center justify-between px-4 h-16">
          <div className="flex items-center space-x-4">
            <Link 
              to="/"
              className="flex items-center text-gray-500 hover:text-gray-700"
              title="返回首页"
            >
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <h1 className="text-xl font-semibold text-gray-900">一雄CMS管理系统</h1>
          </div>
          
          <nav className="flex items-center space-x-4">
            {navigation.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                  location.pathname === item.href
                    ? 'text-gray-900 bg-gray-100'
                    : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                <item.icon className="w-5 h-5 mr-1.5" />
                {item.name}
              </Link>
            ))}
          </nav>

          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-500">{user?.email}</span>
            <Link
              to="/login"
              className="text-sm text-red-600 hover:text-red-500"
            >
              退出
            </Link>
          </div>
        </div>
      </header>

      {/* 主要内容区域 */}
      <main className="p-6">
        <Outlet />
      </main>
    </div>
  );
}